import React from 'react';
import styles from './FinancialReport.module.scss';
import DataTable from 'react-data-table-component';
import { Button, Col, Row } from 'reactstrap';

const data = [
    {
        id: 1,
        category: 'Sales',
        description: 'Total sales revenue',
        amount: '$100,000',
    },
    {
        id: 2,
        category: 'Fulfillment Fees',
        description: 'Fees for picking, packing, and shipping',
        amount: '-$20,000',
    },
    {
        id: 3,
        category: 'Storage Fees',
        description: 'Charges for storing inventory',
        amount: '-$5,000',
    },
    {
        id: 4,
        category: 'Returns & Refunds',
        description: 'Value of returned or refunded items',
        amount: '-$3,000',
    },
    {
        id: 5,
        category: 'Promotions',
        description: 'Cost of promotional activities',
        amount: '-$2,000',
    },
    {
        id: 6,
        category: 'Advertising',
        description: 'Spend on Maelano Advertising',
        amount: '-$1,000',
    },
    {
        id: 7,
        category: 'Net Profit',
        description: 'Total profit after deducting fees and costs',
        amount: '$74,000',
    },
];

const columns = [
    {
        name: 'Category',
        selector: (row) => row.category,
        sortable: true,
    },
    {
        name: 'Description',
        selector: (row) => row.description,
        sortable: true,
        grow: 2,
    },
    {
        name: 'Amount',
        selector: (row) => row.amount,
        sortable: true,
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "30px",
            paddingRight: "30px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 30px',
        },
    },
};

const FinancialReport = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Financial Report</h4>

            <Row className={styles.financialReportRow}>
                <Col sm='12' lg={9}>
                    <DataTable
                        columns={columns}
                        data={data}
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </Col>
            </Row>

            <div className={styles.downloadContainer}>
                <Button
                    color="info"
                    className={styles.downloadButton}
                >
                    Download Detailed Report
                </Button>
            </div>

        </div>
    )
}

export default FinancialReport;